'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function ReturnToAdminButton() {
  const router = useRouter();
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    const checkImpersonation = () => {
      const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
      const originalToken = localStorage.getItem('originalAdminToken');
      
      console.log('🔍 Checking impersonation status:', {
        isImpersonating,
        hasOriginalToken: !!originalToken
      });
      
      setIsImpersonating(isImpersonating);
    };

    checkImpersonation();
    
    // Check periodically
    const interval = setInterval(checkImpersonation, 1000);
    
    return () => clearInterval(interval);
  }, []);

  const handleReturnToAdmin = () => {
    const originalToken = localStorage.getItem('originalAdminToken');
    
    if (originalToken) {
      // Restore admin session
      localStorage.setItem('authToken', originalToken);
      localStorage.removeItem('isImpersonating');
      localStorage.removeItem('originalAdminToken');
      
      // Redirect to admin dashboard
      router.push('/admin/dashboard');
    } else {
      // Fallback: clear everything and go to admin login
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('isImpersonating');
      localStorage.removeItem('originalAdminToken');
      
      router.push('/admin/login');
    }
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-[9999]">
      <div className="bg-purple-600 text-white px-4 py-2 rounded-lg shadow-2xl flex items-center gap-2 border-2 border-purple-700">
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
        <span className="text-sm font-medium">Impersonating User</span>
        <button
          onClick={handleReturnToAdmin}
          className="bg-purple-700 hover:bg-purple-800 px-3 py-1 rounded text-sm font-medium transition-colors"
        >
          Back to Admin Dashboard
        </button>
      </div>
    </div>
  );
}
